import React from 'react';
import { SearchHierarchy } from '../hierarchy/SearchHierarchy';
import { useTab } from '../hooks/useTab';
import { useLocation } from 'react-router-dom';
import { useSite } from './useSite';

const SitesMenu: React.FC = () => {
  useSite();
  const location = useLocation();
  const { tabVal, tabsData } = useTab();
  const currentTabinfo: any = tabsData.find((item: any) => item.index === tabVal);
  return (
    <div>
      {currentTabinfo?.searchHierarchy == false && location.pathname !== '/visit-schedule' ? null : <SearchHierarchy />}
    </div>
  );
};

export default SitesMenu;
